import OutlinedInput from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';

export const PrimaryHoverOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  '&:hover > .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
}));
